import React from 'react';
import { block } from '../utils/cn';
import { Portal } from '../Portal';
import { useBodyScrollLock } from '../utils/useBodyScrollLock';
// import {useFocusTrap} from '../utils//useFocusTrap';
import { useLayer } from '../utils/useLayer';
import { usePreviousValue } from '../utils/usePreviousValue';
import { useForceUpdate } from '../utils/useForceUpdate';
import './Modal.css';
const b = block('modal');
export function Modal({ open = false, keepMounted = false, disableBodyScrollLock = false, 
// disableFocusTrap = false,
disableEscapeKeyDown, disableOutsideClick, onEscapeKeyDown, onEnterKeyDown, onOutsideClick, onClose, children, style, className, contentClassName, 'aria-labelledby': ariaLabelledBy, 'aria-label': ariaLabel, container, qa, }) {
    const contentRef = React.useRef(null);
    const hasBeenOpen = React.useRef(false);
    const inTransition = React.useRef(false);
    const previousOpen = usePreviousValue(open);
    const forceUpdate = useForceUpdate();
    if (open) {
        hasBeenOpen.current = true;
    }
    if (typeof previousOpen !== 'undefined' && !inTransition.current) {
        inTransition.current = open !== previousOpen;
    }
    function handleAnimationEnd(event) {
        if (event.target === event.currentTarget) {
            inTransition.current = false;
            forceUpdate();
        }
    }
    useBodyScrollLock({ enabled: !disableBodyScrollLock && (open || inTransition.current) });
    // useFocusTrap({
    //     enabled: !disableFocusTrap && (open || inTransition.current),
    //     rootRef: contentRef,
    // });
    useLayer({
        open,
        disableEscapeKeyDown,
        disableOutsideClick,
        onEscapeKeyDown,
        onEnterKeyDown,
        onOutsideClick,
        onClose,
        contentRefs: [contentRef],
    });
    if (!keepMounted && !open && !inTransition.current) {
        return null;
    }
    return (React.createElement(Portal, { container: container },
        React.createElement("div", { "data-inited": hasBeenOpen.current ? '' : undefined, onAnimationEnd: handleAnimationEnd, style: style, className: b({ open }, className), "data-qa": qa },
            React.createElement("div", { className: b('table') },
                React.createElement("div", { className: b('cell') },
                    React.createElement("div", { ref: contentRef, tabIndex: -1, role: "dialog", "aria-modal": open, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: b('content', contentClassName) }, children))))));
}
